



























































































































































































import {Component, PropSync, Prop, Watch} from 'vue-property-decorator'
  import { Getter, Action } from "vuex-class";
  import BaseFilter from "@/components/Filter/BaseFilter";
  import { SelectWings, ToggleWings, NumberWings, InputWings } from "wings-ui-components";
  import { TemplatesFilterParams } from "@/store/sms/templates/types";
  import {notifyError} from "@/utils/notify-helper";
  import { MsgTransports } from '@/store/types';
  import {getTranslatedParams} from "@/utils/notify-utils";

  @Component({components: {SelectWings, ToggleWings, NumberWings, InputWings}})
  export default class TemplatesFilter extends BaseFilter<TemplatesFilterParams> {
    @PropSync('filterProp') filterParent!: any;
    @PropSync('runFilter') run!: any;
    @PropSync('show') is_show!: boolean;
    @Prop() transport!: MsgTransports;

    @Getter("templatesStatusList") statusList: any;
    @Getter("priorityList") priorityList: any;
    @Getter("managementTemplates") managementTemplatesList: any;

    @Action("getPartners") actionGetPartners: any;
    @Action("getPartnerUsers") actionGetPartnerUsers: any;
    @Action("getTemplates") actionGetTemplates: any;
    @Action("exportTemplates") actionExportTemplates: any;
    @Action("getManagementTemplates") actionGetManagementTemplates: any;

    private emailTransport: MsgTransports = MsgTransports.EMAIL;
    private mailNotifyTransport: MsgTransports = MsgTransports.MAILNOTIFY;
    private callTransport: MsgTransports = MsgTransports.CALL

    defaultFilter(): TemplatesFilterParams {
      return {
        id: undefined,
        partner: undefined,
        partner_user: undefined,
        name: undefined,
        status: undefined,
        priority: undefined,
        message: undefined,
        content: undefined,
        subject: undefined,
        is_active: '',
        tmpl: undefined,
        vk_message: undefined,
        ok_message: undefined,
        page_number: 1
      }
    }

    storageItemName(): string {
      return `${this.transport}TemplateFilter`;
    }

    params = {transport: this.transport};
    partnersList: any = []
    partnerUsersList: any = []

    async getPartnersList(filter: any) {
      const items = await this.actionGetPartners({...this.params, ...filter});
      this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
    }

    async getPartnerUsersList(filter: any) {
      const newFilter = (this.filter.partner) ? {partner: this.filter.partner, ...filter} : filter
      const items = await this.actionGetPartnerUsers(newFilter);
      this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
    }

    async created() {
      if (this.transport === this.mailNotifyTransport){
        this.actionGetManagementTemplates();
      }
      this.filtered();
      this.scroll();
      if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
      if (this.filter.partner_user) this.partnerUsersList = await this.actionGetPartnerUsers({name: this.filter.partner_user});
    }

    async onFilteredAction(nextPage = false) {
      if (!nextPage) this.filter.page_number = 1;
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Template",
          addititional_info: getTranslatedParams(this.filter)
        };
        const resp = await this.actionGetTemplates({filter: this.filter, transport: this.transport})
        await this.actionLog(this.logObject);
        this.is_last = resp.length == 0;
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(err);
      } finally {
        this.moreLoading = false;
      }
    }

    export(): void {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Export",
        action_status: "success",
        object_type: "Template",
        addititional_info: getTranslatedParams(this.filter)
      }
      this.actionExportTemplates({filter: this.filter, transport: this.transport}).then(()=>{
        this.actionLog(this.logObject);
      }).catch((error: any) =>{
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error)
      })
    };

    @Watch('filter', {immediate: true, deep: true})
    onFilterChanged(val: TemplatesFilterParams) {
      this.filterParent = val;
    }

    @Watch('run')
    onRunFilter(val: boolean) {
      if (!val) return;
      this.filtered();
      this.run = false;
    }
  }
